import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SearchContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <HorizontalContainer className={`${styles.searchContainer} ${className}`} testId={testId}>
        <Wrapper className={styles.wrapper}>{children}</Wrapper>
    </HorizontalContainer>
);

export default SearchContainer;
